import { trpc } from '@/data-loaders';

export const useUnitStudyPeriodList = (unitId: number) => {
  return trpc.unit.getStudyPeriodsByUnitId.useQuery(
    { unitId },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: !!unitId,
    },
  );
};
